import styled from 'styled-components';
import EirLogo from '../images/eir.png';

const PageHeader = () => {
  return (
    <Header>
      <img src={EirLogo} alt='Eir' />
      <span>Eir Claims portal</span>
    </Header>
  );
};

export default PageHeader;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  img {
    width: 5rem;
    height: auto;
    border: none;
  }

  span {
    font-size: 1.6rem;
    font-weight: 700;
    margin-top: 0.5rem;
    line-height: 1;
  }
`;
